import React, {useState, useEffect} from 'react';
import {Button, Modal} from 'react-bootstrap';
import ReactLoading from 'react-loading';
import {auth,db,get_all_registrable_tournaments, getValUserCredentials} from '../utils/firebase-config';
import {query,getDocs,collection,where,onSnapshot, QuerySnapshot} from "firebase/firestore";
function TourneyParticipantOverview(props) {
    const tournament_name = props.tournamentname;
    const number_participants = props.nparticipants
    const [InTourney, setInTounrey] = useState([]);
    const [Loading, setLoading] = useState(true) 
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getParticipants = async(tournament_name) => {
        console.log(`tournament name == ${tournament_name}`)
        const querytourney = query(collection(db,"registration_tournament"), where("tournament_name", "==", tournament_name));
        onSnapshot(querytourney, (snapshot) =>{
            console.log(snapshot.docs[0].data().participants);
            setInTounrey(snapshot.docs[0].data().participants);
            setLoading(false);
        });
    }


    useEffect(() => {
        getParticipants(tournament_name);
    }, [])

    if(Loading){
    return(
    <div className="busy">
        <ReactLoading type='bars' color='grey' height={'2vw'} width={'2vw'} />
    </div>
    )
    }
    else{
        return(<>
        <Button variant="info" onClick={handleShow}>{number_participants}</Button>
        <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
            <Modal.Title>Participants for {tournament_name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul>
                {InTourney.map((participant) => {
                    return  <>
                        <li>
                            {participant.valo_name}
                        </li>
                    </>
                })}
                </ul>
            </Modal.Body>
        </Modal>
        </>)
    }


    
}

export default TourneyParticipantOverview